import react, { useState, useEffect } from 'react';

export default function LoadingBar() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let interval = setInterval(() => {
      setProgress((prev) => {
        if (prev < 30) return prev + Math.random() * 10;
        if (prev < 60) return prev + Math.random() * 5;
        if (prev < 90) return prev + Math.random() * 2;
        return prev + Math.random() * 0.5;
      });
    }, 100);

    return () => {
      if (interval) clearInterval(interval);
    };
  }, []);

  return (
    <div className="absolute inset-0 z-55 w-full h-[5px] overflow-hidden">
      <div
        className="bg-[#12B76A] h-[5px] rounded-tr-[20px] rounded-br-[20px] transition-all duration-100 ease-linear"
        style={{ width: `${progress}%` }}
      ></div>
    </div>
  );
}
